'use client'
import { PrismicRichText } from "@prismicio/react";
import { isFilled } from "@prismicio/client";
/**
 * @typedef {import("@prismicio/client").Content.TextOnlySlice} TextOnlySlice
 * @typedef {import("@prismicio/react").SliceComponentProps<TextOnlySlice>} TextOnlyProps
 * @type {import("react").FC<TextOnlyProps>}
 */
const TextOnly = ({ slice, index, slices }) => {
  const isLast = Array.isArray(slices) && index === slices.length - 1;
  
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-white my-10 ${isLast ? "md:pb-10" : ""}`}
    >
      <div className="px-4 md:px-10">
        {isFilled.richText(slice.primary.text) && (
          <PrismicRichText
            field={slice.primary.text}
            components={{
              paragraph: ({ children }) => (
                <p className="font-neue-haas text-lg font-light">{children}</p>
              ),
              em: ({ children }) => (
                <em className="italic">{children}</em>
              ),
              strong: ({ children }) => (
                <strong className="font-medium">{children}</strong>
              ),
            }}
          />
        )}
      </div>

    </section>
  );
};

export default TextOnly;
